import { jsx as _jsx } from "react/jsx-runtime";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, } from '@material-ui/core';
const useStyle = makeStyles((theme) => {
    return {
        root: {
            zIndex: theme.zIndex.modal + 1,
            color: '#fff',
        },
    };
}, {
    name: 'LoadingScreen',
});
/**
 * This is a component that show a loading spinner over the app.
 */
export const LoadingScreen = () => {
    const classes = useStyle();
    return (_jsx(Backdrop, { className: classes.root, open: true, children: _jsx(CircularProgress, { color: "inherit" }) }));
};
